import { PageLayout } from "~/components/Layout/PageLayout";

export function CoinPlaceholder() {
  return <PageLayout content={null} />;
}
